<template>
  <modal :titulo="tituloCancelar" id="consulta-selo" :loading="loading">

    <card>
      <form @submit.prevent="" class="row gutters-xs form">

        <card-table>

          <thead>
          <tr>
            <th>Código do Selo</th>
            <th width="30px"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(codigo, i) in form.codigos" :key="i">
            <td>{{codigo}}</td>
            <td>
              <v-button :run="remover" :params="[i]" :button="false" :popover="true" class="icon" position="dropleft">
                <i class="fal fa-times" title="Excluir"></i>
              </v-button>
            </td>
          </tr>
          <tr>
            <td colspan="100%">
              <div class="row no-gutters w-100">
                <v-input class="col" :error="validation.codigo"
                         v-model="form.codigo" type="text"/>
                <div class="col-auto">
                  <button class="btn btn-outline-secondary btn-xs" @click="adicionar()" title="Adicionar" type="button">
                    <i class="fa fa-plus"></i>
                  </button>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </card-table>

        <div class="w-100"></div>

        <v-input :error="validation.reembolso" v-model="form.reembolso" v-if="mostrarReembolso"
                 label="Haverá Reembolso?"
                 type="radio" class="col-auto mt-2" :required="true" />

        <v-input :error="validation.anular" v-model="form.anular" v-if="mostrarAnular"
                 label="Anular Selo?"
                 type="radio" class="col-auto mt-2" :required="true" />

        <template v-if="mostrarTipoCancelamentoSP">
          <div class="w-100"></div>
          <v-input type="select" :options="tiposCancelamentoSP"
                   label="Tipo de Cancelamento"
                   v-model="form.tipo" class="col-12"
                   :required="true" />
        </template>

        <div class="w-100"></div>

        <v-input type="select" :options="motivosCancelamentoBA" label="Motivo"
                 v-model="form.motivo" class="col-12" v-if="estado == 'BA'" />

        <v-input type="textarea" label="Motivo" class="col-12" v-else
                 v-model="form.motivo" :error="validation.motivo" />

         <template v-if="novaIntegracaoBA && (motivosCancelamentoBACompleto.find(m => String(m.id) === form.motivo)?.possuiAnexo ?? false)">
           <div class="col-6">
             <v-upload @click.prevent="files = []" v-model="files" :upload="upload" extensions=".pdf" class="form-control icon " :drop="true" :multiple="false">
               <i class="fal fa-file-excel mr-1"></i> Arquivo (PDF)
             </v-upload>
           </div>
           <div class="col-6">
             <v-input type="text" :value="files[0] ? files[0].file.name : ''" :small="true" :disabled="true" class="m-0 pl-1 pr-1">
             <a href="" @click.prevent="files = []" class="btn btn-outline-secondary btn-xs">
               <i class="fal fa-trash-alt"></i>
             </a>
             </v-input>
           </div>
         </template>
      </form>
    </card>

    <template #footer>
      <button type="button" @click.prevent="close()" class="btn btn-outline-secondary mr-auto">Fechar</button>
      <v-button :run="cancelarSelo" class="btn-outline-primary" :popover="true">{{tituloCancelar}}</v-button>
    </template>

  </modal>
</template>

<script>
  import FrontBusiness from "@/business/FrontBusiness.js";
  import SeloBusiness from "@/business/SeloBusiness.js";
  import CardTable from "@/components/Layout/components/CardTable.vue";
  import Card from "@/components/Layout/components/Card.vue";
  import Modal from "@/components/Modal";
  import Utils from "@/commons/Utils.js";
  import RegrasEstaduaisBusiness from "@/business/RegrasEstaduaisBusiness";
  import AnexoBusiness from "@/business/AnexoBusiness";

  export default {
    name: "ModalConsultaSelo",
    components: {CardTable, Card, Modal},

    props: {
      codigos: {type: Array, default: () => []}
    },

    data() {
      return {
        loading: true,
        form: {
          codigos: [],
          reembolso: true,
          anular: true,
          motivo: null,
          file:null,
          tipo: null,
        },
        files:[],
        validation: {},
        erros: [],
        motivosCancelamentoBA: [],
        motivosCancelamentoBACompleto:[]
      }
    },

    async created() {
      await this.definirMotivoCancelamentoBA();
      this.definirMotivoCancelamentoInicial();
      // this.form.motivo = this.estado == 'BA' ? "82" : "Cancelamento realizado para manter a regularidade dos atos de registro";
      this.form.codigos = this.codigos;
      this.$set(this, 'loading', false);
    },

    computed:{

      tituloCancelar() {
        return this.$root.isEstadoPR ? 'Anular Selo' : 'Cancelar Selo';
      },

      estado(){
        return this.$root.config.estado;
      },

      mostrarReembolso(){
        return this.estado == 'GO';
      },

      mostrarAnular(){
        return this.estado == 'PR';
      },

      mostrarTipoCancelamentoSP(){
        return this.estado == 'SP';
      },
      novaIntegracaoBA(){
        return this.$root.isEstadoBA && !this.$root.config.selo.utilizarLegado;
      },

      tiposCancelamentoSP() {
        return [
          { id: 'T_XA', nome: 'Exclusão do Ato: utilizado para anulação de ato selado indevidamente (erro operacional)' },
          { id: 'T_XC', nome: 'Cancelamento do Ato por Ordem Judicial: utilizado para anulação de ato selado cancelado por decisão judicial ou administrativa' }
        ];
      },

    },

    methods: {

      async upload() {
        if(this.files.length > 0){
          this.form.file = await AnexoBusiness.fileToBase64(this.files[0].file);
        }
      },

      async definirMotivoCancelamentoBA() {
        if (this.novaIntegracaoBA) {
          this.motivosCancelamentoBACompleto = await RegrasEstaduaisBusiness.listarMotivoCancelamentoBA();
          this.motivosCancelamentoBA = (this.motivosCancelamentoBACompleto)
            .map(m => ({
              id: String(m.id),
              nome: m.descricao,
            }));
        }else{
          this.motivosCancelamentoBA= [
            {"id": "83", "nome": "Erro de daje"},
            {"id": "1", "nome": "Erro de digitação"},
            {"id": "84", "nome": "Erro de documento"},
            {"id": "82", "nome": "Erro na selagem"},
            {"id": "81", "nome": "Erro selo não impresso"}
          ];
        }
      },

      definirMotivoCancelamentoInicial(){
        if (this.novaIntegracaoBA) {
          this.form.motivo = this.motivosCancelamentoBA?.[0] || null;
        }else{
          this.form.motivo = this.estado == 'BA' ? "82" : "Cancelamento realizado para manter a regularidade dos atos de registro";
        }
      },

      showError(e) {
        FrontBusiness.fullErrorHandler(this, e, '');
      },

      close() {
        FrontBusiness.closeModal();
      },

      async cancelarSelo() {

        if(this.form.motivo.length && this.form.codigos.length) {
          if (this.mostrarTipoCancelamentoSP && !this.form.tipo) {
            FrontBusiness.showError('', 'Selecione o tipo de cancelamento');
            return;
          }
          if (this.$root.isEstadoRJ) {
            let r = await FrontBusiness.showConfirmacao(
              'Esta ação cancelará o selo apenas no sistema Asgard. O selo não será cancelado no TJ. Para concluir o cancelamento, será necessário cancelar o selo manualmente no sistema MAS.',
              'Deseja continuar?',
              null,
              'Tenho certeza que desejo continuar.'
            );
            if (!r?.value) return;
          }
          let codigos = Utils.clone(this.form.codigos)
          let codigosErro = []
          for (let x in codigos) {
            let codigoTemErro = false;
            try {
              if (this.mostrarTipoCancelamentoSP) {
                this.erros = await SeloBusiness.cancelarSP(codigos[x], {
                  tipo: this.form.tipo,
                  motivo: this.form.motivo
                });
              } else {
                this.erros = await SeloBusiness.inutilizar(codigos[x], {
                  reembolso: this.form.reembolso,
                  anular: this.form.anular,
                  motivo: this.form.motivo,
                  file: this.form.file
                });
              }
              for (let e in this.erros) {
                codigoTemErro = true;
                FrontBusiness.showError('', this.erros[e])
              }
            } catch(e) {
              codigoTemErro = true;
              let msg = typeof e === 'string'
                ? e
                : (e?.message || 'Erro ao cancelar selo');
              FrontBusiness.showError('', msg);
            }
            if (codigoTemErro) {
              codigosErro.push(codigos[x]);
            }
          }
          let plural = codigos.length - codigosErro.length > 1 ? 's' : '';
          if (codigosErro.length !== this.form.codigos.length) FrontBusiness.showSuccess('', `Selo${plural} cancelado${plural} com sucesso`);
          this.$set(this.form, 'codigos', codigosErro);
          if (!codigosErro.length) await this.close();
        }

      },

      async adicionar() {
        if (!this.form.codigo) return;
        if (this.form.codigos.includes(this.form.codigo)) return this.form.codigo = null;
        this.form.codigos.push(this.form.codigo)
        this.form.codigo = null
      },

      remover(idx){
        this.form.codigos.splice(idx, 1);
      },

    }

  }
</script>

